module.exports = __webpack_public_path__ + "img/9788959753055.ee08166e.jpg";